module.exports = __webpack_public_path__ + "static/media/folder.bba7ff83.svg";